<template>
  <div class="card">
    <div class="print">
      <img
        v-if="currentPort.brand == 'OXBY'"
        class="logo" src="../../assets/ox/OX-logo1.svg"
      />
      <img
        v-if="currentPort.brand == 'Doelbeleggen'"
        class="db-logo" src="../../assets/db/DB-logo1.svg"
      />
      <h3 style="margin-top:100px;">{{currentPort.brand}}</h3>
        Dorpsstraat 34<br>
        1182 JE Amstelveen<br>
        Nederland
      <p>
        Incassant ID NL22ZZZ625035020000<br>
        Kenmerk machtiging {{intake.rekeningData.iban}}<br>
        Reden betaling: periodieke inleg {{currentPort.brand}}
      </p>
      <p style="margin-top:50px;">
        U heeft toestemming gegeven aan {{currentPort.brand}} (St. Collectieve Beleggersgiro) om
        doorlopende incasso-opdrachten te sturen naar uw bank voor het van uw rekening
        afschrijven van een bedrag overeenkomstig de opdracht van {{currentPort.brand}}. Het
        overeengekomen bedrag zoals door u als periodieke storting aangegeven, wordt altijd op de
        1e werkdag {{intake.goalData.stortingenInterval.toLowerCase()}} bij u afgeschreven.
      </p>
      <p>
        Als u het niet eens bent met een incasso afschrijving dan kunt u deze laten terugboeken.
        Neem hiervoor binnen 8 weken na afschrijving contact op met uw bank. Vraag uw bank naar
        de voorwaarden. Wanneer binnen deze 8 weken beleggingen voor u zijn aangekocht, worden
        deze weer verkocht om uw geld terug te kunnen boeken.
      </p>
      <h3 style="margin-top:50px;">
        {{intake.persoonsData[0].voorletters}} {{intake.persoonsData[0].tussenvoegsel}}
        {{intake.persoonsData[0].achternaam}}
      </h3>
      <p style="margin-bottom:200px;margin-top:0;">
        {{intake.persoonsData[0].straat}}
        {{intake.persoonsData[0].huisnummer}}
        {{intake.persoonsData[0].toevoeging}}<br>
        {{intake.persoonsData[0].postcode}}
        {{intake.persoonsData[0].plaats}}<br>
        {{intake.persoonsData[0].land}}<br>
        IBAN {{intake.rekeningData.iban}}
      </p>
      <div class="docdate">
        Doorlopende Machtiging {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div v-if="currentPort.brand == 'OXBY'" class="pagefooter">
        &copy;&nbsp;OXBY&nbsp;Vermogensbeheer<br>
        Oxby.nl – klantenservice@oxby.nl – 020&nbsp;555&nbsp;0000
        – Dorpsstraat&nbsp;34 – 1182&nbsp;JE&nbsp;Amstelveen<br>
        IBAN&nbsp;NL85&nbsp;ABNA&nbsp;0551&nbsp;6791&nbsp;58
        – KVK&nbsp;34120836 – BTW&nbsp;NL8082.63.559.B01
      </div>
      <div v-if="currentPort.brand == 'Doelbeleggen'" class="pagefooter">
        &copy; info@doelbeleggen.nl – 020&nbsp;555&nbsp;0055 – Dorpsstraat&nbsp;34
        – 1182&nbsp;JE&nbsp;Amstelveen
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntakeCollectPage',
  props: {
    currentPort: Object,
    intake: Object,
    today: Date,
  },
};
</script>

<style lang="scss" scoped>
  @import "../../scss/_paper.scss";
</style>
